/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_AgentInputs */

const en_mk_foot_agent = /** @type {(inputs: Mk_Foot_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Agent`)
};

const id_mk_foot_agent = /** @type {(inputs: Mk_Foot_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Agent`)
};

/**
* | output |
* | --- |
* | "Bystep Agent" |
*
* @param {Mk_Foot_AgentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_agent = /** @type {((inputs?: Mk_Foot_AgentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_AgentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_agent(inputs)
	return en_mk_foot_agent(inputs)
});